
<template>
  <div class="new-class-container">
    <el-card class="new-class-card">
      <div slot="header" class="new-class-header">
        <el-button type="text" icon="el-icon-arrow-left" @click="goToHome" class="back-button">返回</el-button>
        <h2>新建班级</h2>
        <div v-if="teacherInfo" class="teacher-info">
          尊敬的{{ teacherInfo.nickname }}，<br>您已绑定{{ boundClassCount }}个班级，一位老师最多绑定{{ maxClasses }}个班级
        </div>
      </div>

      <form class="new-class-form" @submit.prevent="handleCreateClass">
        <div class="el-form-item">
          <label class="el-form-item__label" style="width: 82px;">班级级别<span class="el-form-item__required" v-if="true"></span></label>
          <div class="el-form-item__content" style="margin-left: 82px;">
            <el-select v-model="newClassForm.gradeLevel" placeholder="请选择班级级别" style="width: 100%;">
              <el-option label="一年级" :value="1"></el-option>
              <el-option label="二年级" :value="2"></el-option>
              <el-option label="三年级" :value="3"></el-option>
              <el-option label="四年级" :value="4"></el-option>
              <el-option label="五年级" :value="5"></el-option>
              <el-option label="六年级" :value="6"></el-option>
              <el-option label="初一" :value="7"></el-option>
              <el-option label="初二" :value="8"></el-option>
              <el-option label="初三" :value="9"></el-option>
              <el-option label="高一" :value="10"></el-option>
              <el-option label="高二" :value="11"></el-option>
              <el-option label="高三" :value="12"></el-option>
            </el-select>
            <div class="el-form-item__error" v-if="!newClassForm.gradeLevel && formErrors.gradeLevel">请选择班级级别</div>
          </div>
        </div>
        
        <div class="el-form-item">
          <label class="el-form-item__label" style="width: 82px;">班别<span class="el-form-item__required" v-if="true"></span></label>
          <div class="el-form-item__content" style="margin-left: 82px;">
            <el-select v-model="newClassForm.classNumber" placeholder="请选择班别" style="width: 100%;">
              <el-option v-for="i in 20" :key="i" :label="i + '班'" :value="i"></el-option>
            </el-select>
            <div class="el-form-item__error" v-if="!newClassForm.classNumber && formErrors.classNumber">请选择班别</div>
          </div>
        </div>
        
        <div class="el-form-item">
          <label class="el-form-item__label" style="width: 82px;">任教科目<span class="el-form-item__required" v-if="true"></span></label>
          <div class="el-form-item__content" style="margin-left: 82px;">
            <el-select v-model="newClassForm.subjectId" placeholder="请选择任教科目" style="width: 100%;" @change="onSubjectChange">
              <el-option label="语文" :value="1"></el-option>
              <el-option label="数学" :value="2"></el-option>
              <el-option label="英语" :value="3"></el-option>
            </el-select>
            <div class="el-form-item__error" v-if="!newClassForm.subjectId && formErrors.subjectId">请选择任教科目</div>
          </div>
        </div>
        
        <div class="el-form-item">
          <label class="el-form-item__label" style="width: 82px;">作业类型<span class="el-form-item__required" v-if="true"></span></label>
          <div class="el-form-item__content" style="margin-left: 82px;">
            <div class="homework-types-container">
              <el-tree
                :data="filteredTreeData"
                :props="defaultProps"
                node-key="id"
                :default-expanded-keys="defaultExpandedKeys"
                ref="tree"
                class="homework-types-tree"
                :render-content="renderContent"
                :expand-on-click-node="false">
              </el-tree>
            </div>
            <div class="el-form-item__error" v-if="!hasHomeworkTypes && formErrors.homeworkTypes">请至少添加一种作业类型</div>
          </div>
        </div>
        
        <div class="el-form-item">
          <label class="el-form-item__label" style="width: 82px;">学生名单<span class="el-form-item__required" v-if="true"></span></label>
          <div class="el-form-item__content" style="margin-left: 82px;">
            <el-button type="primary" @click="showImportDialog = true">导入学生名单</el-button>
            <div class="el-form-item__error" v-if="!hasStudents && formErrors.students">请至少导入一名学生</div>
          </div>
        </div>
        
        <div class="el-form-item" v-if="students.length > 0">
          <label class="el-form-item__label" style="width: 82px;"></label>
          <div class="el-form-item__content" style="margin-left: 82px;">
            <el-table :data="students" style="width: 100%" max-height="300">
              <el-table-column prop="studentNumber" label="学号"></el-table-column>
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="editStudent(scope.row)">编辑</el-button>
                  <el-button size="mini" type="text" @click="deleteStudent(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        
        <div class="el-form-item">
          <label class="el-form-item__label" style="width: 82px;"></label>
          <div class="el-form-item__content" style="margin-left: 82px;">
            <el-button type="primary" native-type="submit" :loading="loading" style="width: 100%;">创建班级</el-button>
          </div>
        </div>
      </form>
    </el-card>
    
    <!-- 导入学生名单弹窗 -->
    <el-dialog title="导入学生名单" :visible.sync="showImportDialog" width="80%" :close-on-click-modal="false">
      <div style="margin-bottom: 10px;">
        <strong>请按以下格式输入学生姓名：</strong><br>
        <span style="color: #999; font-size: 14px;">（每行一个学生姓名，仅限汉字，最多4个字）</span>
      </div>
      <div class="add-students-container" style="position: relative;">
        <el-input
          type="textarea"
          :rows="10"
          :placeholder="'请输入学生姓名，每行一个学生\n格式示例：\n张三\n李四\n王五'"
          v-model="studentsText"
          class="aligned-textarea">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImportDialog = false">取 消</el-button>
        <el-button type="primary" @click="importStudents">确 定</el-button>
      </span>
    </el-dialog>
    
    <!-- 编辑学生弹窗 -->
    <el-dialog title="编辑学生" :visible.sync="showEditDialog" width="80%">
      <el-form :model="currentStudent" :rules="studentRules" ref="studentForm" label-width="80px">
        <el-form-item label="学号" prop="studentNumber">
          <el-input v-model="currentStudent.studentNumber" placeholder="请输入学号"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="currentStudent.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirmEditStudent">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>


export default {
  name: 'NewClassMobile',
  async created() {
    // 验证当前用户的token是否有效
    try {
      // 尝试获取当前登录教师的信息来验证token
      const teacherInfo = JSON.parse(localStorage.getItem('teacherInfo'));
      if (!teacherInfo) {
        // 如果本地没有教师信息，直接跳转到登录
        this.$message.error('请先登录');
        this.$router.push('/loginmobile');
        return;
      }
      
      // 发起一个需要认证的请求来验证token是否有效
      await this.$http.get(`/teachers/profile`);
      
      // 设置教师信息和获取绑定的班级数量
      this.teacherInfo = teacherInfo;
      await this.fetchClassCounts();
    } catch (error) {
      // 请求失败通常意味着token无效或已过期
      if (error.response && error.response.status === 401) {
        this.$message.error('登录已过期，请重新登录');
        this.$router.push('/loginmobile');
      }
    }
  },
  data() {
    return {
      loading: false,
      showImportDialog: false,
      showEditDialog: false,
      studentsText: '',
      students: [],
      currentStudent: {
        id: null,
        studentNumber: '',
        name: ''
      },
      // 教师信息相关
      teacherInfo: null,
      boundClassCount: 0,
      maxClasses: 5,
      newClassForm: {
        gradeLevel: null,
        classNumber: null,
        subjectId: null
      },
      formErrors: {
        gradeLevel: false,
        classNumber: false,
        subjectId: false,
        homeworkTypes: false,
        students: false
      },
      studentRules: {
        studentNumber: [
          { required: true, message: '请输入学号', trigger: 'blur' },
          { pattern: /^\d+$/, message: '学号只能是数字', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { pattern: /^[\u4e00-\u9fa5]{1,4}$/, message: '姓名只能包含1-4个汉字，不能包含英文、数字、标点符号和空格', trigger: 'blur' }
        ]
      },
      // 作业类型树形数据
      treeData: [
        {
          id: 1,
          label: '语文',
          children: [
            {
              id: 11,
              label: '听写本',
              type: 'homework-type'
            }
          ]
        },
        {
          id: 2,
          label: '数学',
          children: [
            {
              id: 21,
              label: '计算题',
              type: 'homework-type'
            }
          ]
        },
        {
          id: 3,
          label: '英语',
          children: [
            {
              id: 31,
              label: '听写本',
              type: 'homework-type'
            }
          ]
        }
      ],
      filteredTreeData: [],
      defaultExpandedKeys: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      defaultCheckedKeys: [11, 21, 31] // 默认选中听写本、计算题、听写本
    }
  },
  computed: {
    hasHomeworkTypes() {
      // 检查是否至少有一个作业类型
      const checkedKeys = this.$refs.tree ? this.$refs.tree.getCheckedKeys() : [];
      const halfCheckedKeys = this.$refs.tree ? this.$refs.tree.getHalfCheckedKeys() : [];
      const allCheckedKeys = [...checkedKeys, ...halfCheckedKeys];
      return allCheckedKeys.length > 0;
    },
    hasStudents() {
      return this.students && this.students.length > 0;
    }
  },
  mounted() {
    // 设置body的padding为0
    document.body.classList.add('mobile-view');
    document.body.classList.add('no-padding');
    document.body.style.padding = '0';
  },
  beforeDestroy() {
    // 在组件销毁前恢复body的padding
    document.body.classList.remove('mobile-view');
    document.body.classList.remove('no-padding');
    document.body.style.padding = '';
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    
    // 获取教师绑定的班级数量
    async fetchClassCounts() {
      try {
        const response = await this.$http.get(`/teachers/hasClass`);
        if (response.data && response.data.success) {
          this.boundClassCount = response.data.classCount || 0;
          this.maxClasses = response.data.maxClasses || 5;
        } else {
          // 如果没有success字段，直接访问数据
          this.boundClassCount = response.data.classCount || 0;
          this.maxClasses = response.data.maxClasses || 5;
        }
      } catch (error) {
        console.error('获取教师班级数量失败:', error);
        // 错误时使用默认值
        this.boundClassCount = 0;
        this.maxClasses = 5;
      }
    },
    
    // 自定义树节点渲染
    renderContent(h, { node, data }) {
      // 检查是否为根节点（科目节点）
      const isRootNode = !this.hasParent(data, this.treeData);
      
      return (
        <span class="custom-tree-node">
          <span class="node-label" onDblclick={() => this.renameNode(data)}>
            {node.label}
          </span>
          <span class="node-buttons">
            {isRootNode ? (
              <el-button
                size="mini"
                type="text"
                disabled={this.isHomeworkTypeLimitReached(data)}
                onClick={() => this.addHomeworkType(data)}>
                添加作业类型
              </el-button>
            ) : (
              <span>
                <el-button
                  size="mini"
                  type="text"
                  onClick={() => this.renameNode(data)}>
                  重命名
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  onClick={() => this.moveNode(data, 'up')}>
                  上移
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  onClick={() => this.moveNode(data, 'down')}>
                  下移
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  onClick={() => this.deleteNode(data)}>
                  删除
                </el-button>
              </span>
            )}
          </span>
        </span>
      );
    },
    
    // 检查节点是否有父节点
    hasParent(node, treeData) {
      for (let i = 0; i < treeData.length; i++) {
        const item = treeData[i];
        if (item.children && item.children.some(child => child.id === node.id)) {
          return true;
        }
      }
      return false;
    },
    
    // 添加作业类型
    addHomeworkType(parentNode) {
      this.$prompt('请输入作业类型名称', '添加作业类型', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: '',
        inputPlaceholder: '请输入作业类型名称',
        inputValidator: (value) => {
          if (!value || value.trim() === '') return '请输入作业类型名称';
          if (value.length > 30) return '作业类型名称不能超过30个字符';
          // 检查是否存在同名的作业类型
          if (parentNode.children && parentNode.children.some(child => child.label.trim() === value.trim())) {
            return '该作业类型名称已存在，请输入不同的名称';
          }
          return true;
        },
        inputErrorMessage: '作业类型名称格式不正确',
        closeOnClickModal: false
      }).then(({ value }) => {
        const newId = Date.now(); // 生成唯一ID
        const newHomeworkType = {
          id: newId,
          label: value.trim(),
          type: 'homework-type'
        };
        
        // 如果父节点没有children数组，则创建一个
        if (!parentNode.children) {
          parentNode.children = [];
        }
        
        // 添加新作业类型
        parentNode.children.push(newHomeworkType);
        
        // 更新filteredTreeData以反映变化
        if (this.newClassForm.subjectId) {
          const selectedSubject = this.treeData.find(item => item.id === this.newClassForm.subjectId);
          if (selectedSubject) {
            this.filteredTreeData = [selectedSubject];
          }
        }
        
        // 展开节点并选中新添加的节点
        this.$nextTick(() => {
          this.$refs.tree.setChecked(newId, true, true);
          // 展开父节点以显示新添加的子节点
          this.$refs.tree.store.nodesMap[parentNode.id].expanded = true;
        });
      }).catch(() => {
        // 用户取消操作或点击空白处
        console.log('用户取消添加作业类型');
      });
    },
    
    // 重命名节点
    renameNode(data) {
      // 找到当前节点的父节点
      const parentNode = this.findParentNode(this.treeData, data);
      
      this.$prompt('请输入新的作业类型名称', '重命名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: data.label,
        inputValidator: (value) => {
          if (!value) return '请输入作业类型名称';
          if (value.length > 30) return '作业类型名称不能超过30个字符';
          // 检查是否存在同名的作业类型
          if (parentNode && parentNode.children && 
              parentNode.children.some(child => child.id !== data.id && child.label.trim() === value.trim())) {
            return '该作业类型名称已存在，请输入不同的名称';
          }
          return true;
        },
        inputErrorMessage: '作业类型名称格式不正确'
      }).then(({ value }) => {
        data.label = value;
      }).catch(() => {
        // 取消操作
      });
    },
    
    // 为当前科目添加作业类型
    addHomeworkTypeForSubject() {
      if (!this.newClassForm.subjectId) {
        this.$message.warning('请先选择任教科目');
        return;
      }
      
      const subject = this.treeData.find(item => item.id === this.newClassForm.subjectId);
      if (subject) {
        this.addHomeworkType(subject);
      }
    },
    
    // 移动节点
    moveNode(data, direction) {
      // 找到当前节点的父节点
      const parentNode = this.findParentNode(this.treeData, data);
      if (!parentNode || !parentNode.children) {
        return;
      }
      
      const siblings = parentNode.children;
      const index = siblings.findIndex(item => item.id === data.id);
      
      if (index === -1) return;
      
      if (direction === 'up' && index > 0) {
        // 上移：与前一个元素交换位置
        [siblings[index - 1], siblings[index]] = [siblings[index], siblings[index - 1]];
      } else if (direction === 'down' && index < siblings.length - 1) {
        // 下移：与后一个元素交换位置
        [siblings[index], siblings[index + 1]] = [siblings[index + 1], siblings[index]];
      }
      
      // 更新filteredTreeData以反映变化
      if (this.newClassForm.subjectId) {
        const selectedSubject = this.treeData.find(item => item.id === this.newClassForm.subjectId);
        if (selectedSubject) {
          this.filteredTreeData = [selectedSubject];
        }
      }
    },
    
    // 查找节点的父节点
    findParentNode(treeData, targetNode) {
      for (let i = 0; i < treeData.length; i++) {
        const item = treeData[i];
        if (item.children) {
          if (item.children.some(child => child.id === targetNode.id)) {
            return item;
          }
          // 递归查找
          const found = this.findParentNode(item.children, targetNode);
          if (found) return found;
        }
      }
      return null;
    },
    isHomeworkTypeLimitReached(subjectData) {
      if (!subjectData.children) {
        return false;
      }
      return subjectData.children.length >= 20;
    },
    
    // 删除节点
    deleteNode(data) {
      this.$confirm('确定要删除该作业类型吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 找到当前节点的父节点
        const parentNode = this.findParentNode(this.treeData, data);
        if (parentNode && parentNode.children) {
          // 从父节点的children中移除当前节点
          parentNode.children = parentNode.children.filter(child => child.id !== data.id);
          
          // 更新filteredTreeData以反映变化
          if (this.newClassForm.subjectId) {
            const selectedSubject = this.treeData.find(item => item.id === this.newClassForm.subjectId);
            if (selectedSubject) {
              this.filteredTreeData = [selectedSubject];
            }
          }
          
          this.$message.success('删除成功');
        }
      }).catch(() => {
        // 用户取消删除
      });
    },
    
    // 根据选择的科目更新树形数据
    onSubjectChange(subjectId) {
      // 根据选择的科目过滤树形数据
      if (subjectId) {
        const selectedSubject = this.treeData.find(item => item.id === subjectId);
        if (selectedSubject) {
          this.filteredTreeData = [selectedSubject];
          this.defaultExpandedKeys = [subjectId];
          
          // 自动选中该科目的所有作业类型
          const allChildIds = [];
          const collectIds = (node) => {
            if (node.children) {
              node.children.forEach(child => {
                allChildIds.push(child.id);
                collectIds(child);
              });
            }
          };
          collectIds(selectedSubject);
          
          this.defaultCheckedKeys = allChildIds;
          
          // 由于Vue的响应式特性，需要延迟设置选中项
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(allChildIds);
          });
        }
      } else {
        // 如果没有选择科目，则显示全部
        this.filteredTreeData = this.treeData;
        this.defaultExpandedKeys = [1, 2, 3];
        this.defaultCheckedKeys = [11, 21, 31];
      }
    },
    
    async handleCreateClass() {
      // 清除之前的错误
      this.formErrors.gradeLevel = false;
      this.formErrors.classNumber = false;
      this.formErrors.subjectId = false;
      this.formErrors.homeworkTypes = false;
      this.formErrors.students = false;
      
      let isValid = true;
      
      // 验证必填字段
      if (!this.newClassForm.gradeLevel) {
        this.formErrors.gradeLevel = true;
        isValid = false;
      }
      if (!this.newClassForm.classNumber) {
        this.formErrors.classNumber = true;
        isValid = false;
      }
      if (!this.newClassForm.subjectId) {
        this.formErrors.subjectId = true;
        isValid = false;
      }
      
      // 获取选中的作业类型
      const selectedHomeworkTypes = [];
      if (this.filteredTreeData && this.filteredTreeData.length > 0) {
        // 遍历过滤后的树数据，收集所有叶子节点（作业类型）
        const collectHomeworkTypes = (nodes, currentIndex = 0) => {
          nodes.forEach(node => {
            if (node.type === 'homework-type') {
              // 只有作业类型节点才添加到列表
              selectedHomeworkTypes.push({
                name: node.label,
                subjectId: this.newClassForm.subjectId,
                sortOrder: currentIndex + 1
              });
              currentIndex++;
            } else if (node.children && node.children.length > 0) {
              // 如果有子节点，递归遍历
              currentIndex = collectHomeworkTypes(node.children, currentIndex);
            }
          });
          return currentIndex;
        };
        collectHomeworkTypes(this.filteredTreeData);
      }
      
      // 验证作业类型不能为空
      if (!selectedHomeworkTypes || selectedHomeworkTypes.length === 0) {
        this.formErrors.homeworkTypes = true;
        isValid = false;
      }
      
      // 验证学生名单不能为空
      if (!this.students || this.students.length === 0) {
        this.formErrors.students = true;
        isValid = false;
      }
      
      if (!isValid) {
        this.$message.error('请完善必填信息');
        return;
      }
      
      try {
        this.loading = true;
        
        // 获取当前登录教师信息
        const teacherInfo = JSON.parse(localStorage.getItem('teacherInfo'));
        if (!teacherInfo) {
          this.$message.error('请先登录');
          this.$router.push('/loginmobile');
          return;
        }
        
        const response = await this.$http.post('/classes/create', {
          teacherId: teacherInfo.id,
          gradeLevel: this.newClassForm.gradeLevel,
          classNumber: this.newClassForm.classNumber,
          subjectId: this.newClassForm.subjectId,
          homeworkTypes: selectedHomeworkTypes,
          students: this.students
        });
        
        if (response.data.success) {
          this.$message.success(response.data.message);
          
          // 获取新创建的班级ID并跳转到对应的班级首页
          const newClassId = response.data.class.id;
          // 根据选择的科目进行跳转
          const subjectId = this.newClassForm.subjectId;
          this.$router.push(`/mobile/class/${newClassId}?subjectId=${subjectId}`);
        } else {
          this.$message.error(response.data.message);
        }
      } catch (error) {
        console.error('创建班级失败:', error);
        this.$message.error('创建班级失败，请重试');
      } finally {
        this.loading = false;
      }
    },
    
    // 导入学生
    importStudents() {
      // 检查是否已有学生名单，如果有则提示是否覆盖
      if (this.students && this.students.length > 0) {
        this.$confirm('检测到您当前页面已经导入了数据，再次导入会覆盖原有数据，是否继续？', '提示', {
          confirmButtonText: '继续导入',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.performImportStudents();
        }).catch(() => {
          // 用户取消导入
          console.log('用户取消导入学生');
        });
      } else {
        this.performImportStudents();
      }
    },
    
    // 执行导入学生的核心逻辑
    performImportStudents() {
      const lines = this.studentsText.split('\n').filter(line => line.trim() !== '');
      const invalidLines = [];
      const validStudents = [];
      
      // 验证学生姓名格式
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (line === '') continue;
        
        // 验证格式：仅限汉字，不超过4个字符，不含标点符号和空格
        if (!/^[\u4e00-\u9fa5]{1,4}$/.test(line)) {
          invalidLines.push({ line: i + 1, content: line });
        } else {
          validStudents.push({
            studentNumber: (validStudents.length + 1).toString(),
            name: line,
            line: i + 1  // 添加行号信息用于重名提示
          });
        }
      }
      
      if (invalidLines.length > 0) {
        let errorMsg = '以下行格式不正确：\n';
        invalidLines.forEach(item => {
          errorMsg += `第${item.line}行: ${item.content}\n`;
        });
        this.$alert(errorMsg.replace(/\n/g, '<br/>'), '格式错误', {
          confirmButtonText: '确定',
          type: 'error',
          dangerouslyUseHTMLString: true
        });
        return;
      }
      
      // 验证通过，添加学生
      if (validStudents.length > 70) {
        this.$alert(
          `新建班级时学生人数不能超过70人<br/>
           当前导入：${validStudents.length}人`, 
          '人数超限', {
          confirmButtonText: '确定',
          type: 'error',
          dangerouslyUseHTMLString: true
        }).catch(() => {
          // 用户点击关闭按钮或遮罩层时的处理
          console.log('用户关闭了人数超限弹窗');
        });
        return;
      }
      
      // 检查学生姓名重名情况
      const nameCounts = {};
      const duplicateNames = [];
      
      // 统计待添加学生中的重名
      for (const student of validStudents) {
        if (nameCounts[student.name]) {
          nameCounts[student.name].count++;
          nameCounts[student.name].lines.push(student.line);
        } else {
          nameCounts[student.name] = {
            count: 1,
            lines: [student.line]
          };
        }
      }
      
      // 收集重名信息
      for (const [name, info] of Object.entries(nameCounts)) {
        if (info.count > 1) {
          duplicateNames.push({
            name: name,
            lines: info.lines
          });
        }
      }
      
      // 如果有重名，提示用户
      if (duplicateNames.length > 0) {
        let errorMsg = '发现重名学生，请修改后再导入：<br/><br/>';
        duplicateNames.forEach(dup => {
          errorMsg += `姓名"${dup.name}"在第${dup.lines.join('、')}行重复<br/>`;
        });
        
        this.$alert(errorMsg, '重名检查', {
          confirmButtonText: '确定',
          type: 'error',
          dangerouslyUseHTMLString: true
        }).catch(() => {
          // 用户取消操作
        });
        return;
      }
      
      // 为每个学生分配唯一ID
      const studentsWithId = validStudents.map((student, index) => ({
        ...student,
        id: Date.now() + index // 确保ID唯一性
      }));
      
      this.students = studentsWithId;
      this.showImportDialog = false;
      this.studentsText = '';
    },
    
    // 编辑学生
    editStudent(student) {
      this.currentStudent = { ...student };
      this.showEditDialog = true;
    },
    
    // 确认编辑学生
    async confirmEditStudent() {
      try {
        await this.$refs.studentForm.validate();
        
        // 检查学号是否已存在
        const existingStudent = this.students.find(s => 
          s.studentNumber === this.currentStudent.studentNumber && s.id !== this.currentStudent.id
        );
        
        if (existingStudent) {
          this.$message.error('该学号已存在');
          return;
        }
        
        // 更新学生信息
        const index = this.students.findIndex(s => s.id === this.currentStudent.id);
        if (index !== -1) {
          this.students.splice(index, 1, { ...this.currentStudent });
        } else {
          // 如果是新学生，添加到列表
          this.currentStudent.id = Date.now(); // 临时ID
          this.students.push({ ...this.currentStudent });
        }
        
        this.showEditDialog = false;
        this.$refs.studentForm.resetFields();
      } catch (error) {
        console.error('编辑学生失败:', error);
      }
    },
    
    // 删除学生
    deleteStudent(student) {
      this.$confirm(`确定要删除学生 ${student.name} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.students = this.students.filter(s => s.id !== student.id);
        this.$message.success('删除成功');
      }).catch(() => {
        // 取消删除
      });
    }
  }
}
</script>

<style scoped>
::v-deep .custom-tree-node {
  flex: 1 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  font-size: 14px;
  padding-right: 8px;
  width: 100% !important;
  min-width: 0; /* 确保flex项目可以缩小 */
}

::v-deep .node-label {
  flex: 1 !important;
  min-width: 0 !important; /* 允许文本缩小时收缩 */
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

::v-deep .node-buttons {
  margin-left: 10px;
  display: flex !important;
  align-items: center !important;
}

.new-class-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #F56C6C, #ff8e8e);
  padding: 10px; /* 减少padding以适应移动端 */
}

.new-class-card {
  width: 100%;
  max-width: 600px;
  border-radius: 15px;
  overflow: hidden;
}

/* 设置el-card__body的左右padding为10px */
::v-deep .el-card__body {
  padding: 20px 10px !important;
}

.new-class-header {
  background: linear-gradient(90deg, #F56C6C, #ff8e8e);
  color: white;
  padding: 20px;
  margin: -20px -20px 20px -20px;
}

.new-class-header h2 {
  margin: 10px 0 0 0;
  text-align: center;
}

.back-button {
  color: white;
  padding: 0;
  font-size: 14px;
}

.back-button:hover {
  color: #ffffff;
}

.new-class-form {
  padding: 0px;
}

.homework-types-container {
  width: 100%;
}

.homework-types-tree {
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  padding: 10px 0px 10px 0px; /* 去掉左右padding，保留上下padding */
  max-height: 300px;
  overflow-y: auto;
  margin-top: 5px;
}

.node-buttons .el-button {
  margin-left: 8px;
  padding: 2px 10px;
  font-size: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #f5f7fa;
  color: #606266;
}

.el-form-item {
  margin-bottom: 22px;
}

.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px !important;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  font-weight: normal !important;
  line-height: 1.5 !important;
}

.el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
}

.el-form-item__content::after {
  clear: both;
}

.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}

.el-form-item__required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

.el-form-item__content::after {
  clear: both;
}

.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}

.el-form-item__required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

/* 移动端对话框样式调整 */
::v-deep .el-dialog {
  margin: 10px !important;
  width: calc(100% - 20px) !important;
}

/* 学生名单表格列宽调整 */
::v-deep .el-table .el-table__header th:nth-child(1),
::v-deep .el-table .el-table__body td:nth-child(1) {
  padding: 2px 4px !important;
}

::v-deep .el-table .el-table__header th:nth-child(3),
::v-deep .el-table .el-table__body td:nth-child(3) {
  width: 150px !important;
  padding: 2px 4px !important;
}

/* 教师信息样式 */
.teacher-info {
  margin-top: 10px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 1.5;
}

/* 输入框样式增强 - 保持与项目规范一致 */
::v-deep .el-input__inner {
  font-size: 14px !important;
  font-weight: normal !important;
}

::v-deep .el-select .el-input__inner {
  font-size: 14px !important;
  font-weight: normal !important;
}
</style>